/*
 * returns the auth token from the rails generated meta[name=csrf-token]
 */
export default document.querySelector('meta[name=csrf-token]').getAttribute('content');
